module.exports = __webpack_public_path__ + "static/media/Cecil-icon-01-01-sm.122ee84b.png";